<template>
  <div class="layout">
    <aside class="sidebar">
      <div class="brand"><div class="brand-logo">鲸</div><div><strong>鲸迹·知行</strong><span>医药代表 AI 行为管理系统</span></div></div>
      <nav>
        <template v-for="group in visibleGroups">
          <div :key="group.title" class="nav-group">{{ group.title }}</div>
          <router-link v-for="item in group.items" :key="item.path" :to="'/' + item.path" class="nav-item">
            <span class="ico">{{ item.icon }}</span><span>{{ item.title }}</span>
            <em v-if="item.ai">AI</em>
          </router-link>
        </template>
      </nav>
    </aside>
    <main class="main">
      <header class="topbar">
        <div><h2>{{ $route.meta.title }}</h2><span class="version">V1.2 · AI-Native</span></div>
        <div class="user">
          <span class="ai-dot">🤖</span>
          <div><strong>{{ user.display_name || '赵总监' }}</strong><small>{{ user.role_code || 'SUPER_ADMIN' }}</small></div>
          <el-dropdown @command="command"><span class="el-dropdown-link">⌄</span><el-dropdown-menu slot="dropdown"><el-dropdown-item command="password">修改密码</el-dropdown-item><el-dropdown-item command="logout">退出登录</el-dropdown-item></el-dropdown-menu></el-dropdown>
        </div>
      </header>
      <section class="workspace"><router-view /></section>
    </main>
  </div>
</template>
<script>
export default {
  data: () => ({
    groups: [
      { title: '总览', items: [{ path: 'dashboard', title: 'AI 工作台', icon: '📊', permission: 'dashboard.read' }] },
      { title: 'AI 智能', items: [
        { path: 'ai-assistant', title: 'AI 合规助手', icon: '💬', ai: true, permission: 'ai-assistant.read' }
      ] },
      { title: '基础数据中心', items: [
        { path: 'terminal', title: '终端信息库', icon: '🏥', permission: 'terminal.read' },
        { path: 'region', title: '省区管理', icon: '🗺️', permission: 'region.read' },
        { path: 'org', title: '人员组织库', icon: '👥', permission: 'org.read' },
        { path: 'role', title: '角色管理', icon: '🔐', permission: 'role.read' },
        { path: 'product', title: '产品信息库', icon: '💊', permission: 'product.read' }
      ] },
      { title: '行为记录', items: [
        { path: 'plan', title: '医生排班管理', icon: '🗓️', permission: 'plan.read' },
        { path: 'visit', title: '拜访记录', icon: '📝', permission: 'visit.read' },
        { path: 'meeting', title: '科室会记录', icon: '🎤', permission: 'meeting.read' },
        { path: 'training', title: '培训学习', icon: '📚', permission: 'training.read' },
        { path: 'feedback', title: '客户反馈', icon: '💬', permission: 'feedback.read' }
      ] },
      { title: '绩效与协同', items: [
        { path: 'kpi', title: '考核看板', icon: '🏆', permission: 'kpi.read' },
        { path: 'closeloop', title: '协同闭环', icon: '🔁', permission: 'feedback.write' }
      ] },
      { title: '合规与权限', items: [
        { path: 'compliance', title: '合规校验', icon: '🛡️', permission: 'compliance.read' },
        { path: 'audit', title: '日志中心', icon: '📋', permission: 'audit.read' }
      ] }
    ]
  }),
  computed: {
    user () { return this.$store.state.user || {} },
    visibleGroups () { return this.groups.map(group => Object.assign({}, group, { items: group.items.filter(item => this.$store.getters.can(item.permission)) })).filter(group => group.items.length) }
  },
  methods: {
    async command (value) {
      if (value === 'password') { this.$root.$emit('password-change:open'); return }
      if (value !== 'logout') return
      try { await this.$store.dispatch('logout') } catch (error) {
        if (!error.authExpired) this.$message.error(error.message)
      } finally {
        if (this.$route.path !== '/login') this.$router.replace('/login')
      }
    }
  }
}
</script>
<style scoped>
.layout{height:100%;display:flex}.sidebar{width:246px;background:linear-gradient(180deg,#073f63,#062f4b);color:#fff;overflow-y:auto;flex:none}.brand{height:86px;padding:17px 18px;display:flex;align-items:center;gap:12px;border-bottom:1px solid rgba(255,255,255,.1)}.brand-logo{width:44px;height:44px;background:#fff;color:#087bb7;border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:25px;font-weight:800}.brand strong{font-size:18px;letter-spacing:2px;display:block}.brand span{display:block;font-size:10px;color:#a9d3e7;margin-top:4px}.nav-group{font-size:11px;color:#77aac3;padding:20px 20px 7px}.nav-item{height:43px;margin:2px 10px;padding:0 12px;display:flex;align-items:center;gap:10px;color:#cee4ef;text-decoration:none;border-radius:7px;font-size:13px}.nav-item:hover{background:rgba(255,255,255,.07)}.nav-item.router-link-active{background:linear-gradient(90deg,#0c87c4,#1376a6);color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.12)}.nav-item .ico{width:20px}.nav-item em{margin-left:auto;background:#7657ce;padding:2px 5px;border-radius:5px;font-size:9px;font-style:normal}.main{flex:1;min-width:0;display:flex;flex-direction:column}.topbar{height:68px;background:#fff;border-bottom:1px solid #e3ebf0;padding:0 26px;display:flex;align-items:center;justify-content:space-between;flex:none}.topbar h2{display:inline;font-size:20px}.version{margin-left:12px;color:#8b98a2;font-size:11px}.user{display:flex;align-items:center;gap:9px}.user small{display:block;color:#8a98a3;margin-top:3px}.ai-dot{width:38px;height:38px;border-radius:50%;background:#f1ebff;display:flex;align-items:center;justify-content:center}.el-dropdown-link{cursor:pointer;padding:8px}.workspace{overflow:auto;flex:1}
</style>
